import Vue from 'vue'
import axios from 'axios';
import * as _ from 'lodash';

export default {
    state: {
        restaurateurs: []
    },
    mutations: {
        fetchRestaurateurs(state, payload) {
            // default order by name
            state.restaurateurs = _.orderBy(payload, restaurateur => restaurateur.name);
        },
        setRestaurateurs(state, payload) {
            state.restaurateurs = payload;
        },
        createNewRestaurateur(state, payload) {
            state.restaurateurs.push(payload);
        },
        deleteRestaurateur(state, payload) {
            state.restaurateurs.map((restaurateur,index) => {
                if (restaurateur.id == payload.id) {
                    state.restaurateurs.splice(index,1);
                }
            })
        },
        editRestaurateur(state, payload){
            const index = state.restaurateurs.findIndex(item => item.id === payload.id);
            Vue.set(state.restaurateurs, index, payload);
        },
    },

    actions: {
        async fetchRestaurateurs({ commit, dispatch }){
            if (!this.state.drivers.promisesStatus.fetchCities) {
                commit('clearError')
                commit('setLoading', true)

                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/restaurateur`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchRestaurateurs', data);
                    commit('setPromiseStatus', { promiseName: 'fetchRestaurateurs', status: true });
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            }
        },
        async createNewRestaurateur({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/restaurateur`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('createNewRestaurateur', data);
                commit('addAreaRestaurateur', data);
                return data;
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },
        async deleteRestaurateur({commit, dispatch}, payload)
        {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/restaurateur/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('deleteRestaurateur', data);
                commit('deleteAreaRestaurateur', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },

        async editRestaurateur({commit, dispatch}, payload){
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/restaurateur/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('editRestaurateur', data)
                commit('editAreaRestaurateur', data)
                commit('setLoading', false)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        }
    },

    getters: {
        restaurateurs (state) {
            return state.restaurateurs
        },
        restaurateurById(state) {
            return restaurateurId => {
                return state.restaurateurs.find(restaurateur => restaurateur.id === restaurateurId)
            }
        }
    }
}